import React from 'react'
import Faq from './faq'
import Faqtwo from './faqtwo'
import Byjus_Advantage from './byjus_advantage'
import { Col, Container, Row } from 'reactstrap'
import Branchmapsection from 'components/branchDetails/branch_map_section'
import antheappbanner from '../../assets/Anthe_banner_app.png'
import antheappbannerm from '../../assets/Anthe_app_mobile.png'

const RightsideBar = (props) => {
    return (
        <>
            <Container className="mt-3 mt-lg-0 mw-100 bg-light">
                <Row id="Visit_new_branch_sec">
                    <Col
                        sm={12}
                        lg={8}
                        className=" my-xl-3 mb-xl-2 px-0 mb-3 d-block d-sm-none"
                    >
                        {/* <a href="https://onelink.to/uw685n" target="_blank"><img src={antheappbannerm} className='img-fluid ' alt="banner" />
                        </a> */}
                    </Col>
                     <Col
                        sm={12}
                        lg={8}
                        className=" my-xl-3 mb-xl-2 px-0 mb-3 d-none d-sm-block d-lg-none"
                    >
                        {/* <a href="https://onelink.to/uw685n" target="_blank">                       
                        <img src={antheappbanner} className='img-fluid ' alt="banner" />
                        </a> */}
                    </Col>
                    <Col
                        sm={12}
                        //md={7}
                        lg={4}
                        className="mb-3 my-xl-3 mb-xl-2 px-0 px-md-2 pe-md-1"
                    >
                        <Byjus_Advantage
                            token={props.token}
                            profileData={props.profileData}
                        />
                    </Col>
                    <Col
                        sm={12}
                        lg={8}
                        className="my-xl-3 mb-xl-0 d-none d-lg-block pe-0"
                    >
                        {/* <a href="https://onelink.to/uw685n" target="_blank">
                        <img src={antheappbanner} className='img-fluid' alt="banner" />
                        </a> */}
                    </Col>
                    <Col
                        sm={12}
                        lg={8}
                        className=" my-xl-3 mb-xl-2 px-3 map bg-white"
                    >
                        <h5 className="text-start m-3 mx-2">Branches Near you</h5>
                        <Branchmapsection
                            token={props.token}
                            profileData={props.profileData}
                        />
                    </Col>
                    <Col
                        sm={12}
                        //md={5}
                        lg={4}
                        className="mb-3 my-xl-3 mb-xl-0 px-0 px-lg-1 mt-2"
                    >
                        {props.profileData.anthetwo ?
                            <Faqtwo token={props.token} profileData={props.profileData} isResultAwaited={props?.isResultAwaited} />
                            :
                            <Faq token={props.token} profileData={props.profileData} isResultAwaited={props?.isResultAwaited} />
                        }
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default RightsideBar
